import { Field, Form, Formik } from "formik";
import { useIntl } from "react-intl";
import { Input } from "../../../../common/components/control/InputField";
import { withdrawSchema } from "../../yupSchema/withdrawSchema";
import { useAuth } from "../../../../auth/components/AuthInit";

export const WithdrawForm = ({
  formikRef,
  saveValues,
  mainWallet,
  floatingBalance,
}) => {
  const intl = useIntl();
  const { auth } = useAuth();

  return (
    <Formik
      initialValues={{
        amount: "",
      }}
      innerRef={formikRef}
      validationSchema={withdrawSchema(intl)}
      enableReinitialize={true}
      onSubmit={(values, formikHelpers) => {
        const queryParams = {
          amount: values.amount,
        };

        saveValues(queryParams);
      }}
    >
      {({
        values,
        handleSubmit,
        setFieldValue,
        touched,
        errors,
        setFieldError,
      }) => (
        <Form>
          <div className="mb-2 position-relative">
            <Field
              name="amount"
              component={Input}
              placeholder={intl.formatMessage({ id: "amount" })}
              label={intl.formatMessage({ id: "amount" })}
              autoComplete="off"
              type="number"
            />
            <div
              className="position-absolute text-prim cursor-pointer"
              style={{ right: "35px", top: "39px" }}
              onClick={() => {
                const [mainBal] = mainWallet.split(".");

                setFieldValue("amount", mainBal.replaceAll(",", ""));
              }}
            >
              {intl.formatMessage({ id: "all" })}
            </div>
          </div>
          <div className="small d-flex justify-content-end align-items-center">
            <div className="d-flex align-items-center pe-2 me-2 custom-border-end">
              <div className="text-muted me-2">
                {intl.formatMessage({ id: "pending" })} :
              </div>
              <div className="fw-semibold">
                {auth.currencycode} {floatingBalance}
              </div>
            </div>
            <div className="d-flex align-items-center">
              <div className="text-muted me-2">
                {intl.formatMessage({ id: "available" })} :
              </div>
              <div className="fw-semibold">
                {auth.currencycode} {mainWallet}
              </div>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};
